
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SimulationMap from './SimulationMap.vue';
import { GeneticsMapGroup, GeneticsMap } from '@/services/crossbreeding-service/models';

@Component({
  components: { SimulationMap }
})
export default class SimulationMapGroup extends Vue {
  @Prop({ type: Object, required: true }) readonly group!: GeneticsMapGroup;
  @Prop({ type: Object }) readonly highlightedMap: GeneticsMap;
  @Prop({ type: Number }) readonly index: number;

  backingMapHeight = 0;
  addAnimationAppearClass = false;

  isLongPressingMap = false;
  isMouseHoveringBackingMap = false;
  showAlternateCards = false;
  showAlternateCardsTimeoutRef: NodeJS.Timeout | null;

  appearAnimationDuration = 300;

  get hasBrowsingMessageSlotContent() {
    return this.$slots.browsingMessage;
  }

  get mapList() {
    return this.group.mapList.filter((map, index) => index === 0 || this.showAlternateCards);
  }

  mounted() {
    this.playAppearAnimation();
  }

  @Watch('index')
  onIndexChange() {
    this.playAppearAnimation();
  }

  playAppearAnimation() {
    this.showAlternateCards = false;
    this.addAnimationAppearClass = false;
    this.onNextTickRerender(() => {
      this.addAnimationAppearClass = true;
    });
    if (this.showAlternateCardsTimeoutRef) {
      clearTimeout(this.showAlternateCardsTimeoutRef);
    }
    // Alternate cards should be shown after the entry animation is finished to prevent animation flicker.
    this.showAlternateCardsTimeoutRef = setTimeout(() => {
      this.showAlternateCardsTimeoutRef = null;
      this.setForcedHeight();
      this.showAlternateCards = true;
    }, this.appearAnimationDuration);
  }

  updated() {
    this.setForcedHeight();
  }

  setForcedHeight() {
    if (this.$refs.primaryMap) {
      this.backingMapHeight = ((this.$refs.primaryMap as Vue[])[0]?.$el as HTMLElement).offsetHeight;
    }
  }

  handleMapClick(index: number) {
    if (index !== 0) {
      this.handleBackingMapClick();
    } else {
      this.handlePrimaryMapClick(this.group.mapList[index]);
    }
  }

  handleBackingMapClick() {
    this.$emit('group-selected', this.group);
  }

  handlePrimaryMapClick(map: GeneticsMap) {
    setTimeout(() => {
      this.$emit('map-selected', map);
    }, 100);
  }

  handleBackingMapMouseEnter() {
    this.isMouseHoveringBackingMap = true;
  }

  handleMouseLeave(index: number) {
    if (index === 0) {
      this.isLongPressingMap = false;
    } else {
      this.isMouseHoveringBackingMap = false;
    }
  }

  handleMouseDown() {
    this.isLongPressingMap = true;
    setTimeout(() => {
      if (this.isLongPressingMap) {
        this.$emit('group-selected', this.group);
      }
    }, 500);
  }

  handleMouseUp() {
    this.isLongPressingMap = false;
  }
}
